import React, { useCallback, useEffect, useState } from "react";
import classes from "./RangeCalendar.module.scss";
import { getTimeStringDate } from "src/utils/getTimeFromString";
import CustomTimePicker from "../CustomTimePicker";

let count = 0;

export const RangeCalendar = (props) => {
    const { onChangeSelectedDate, data } = props

    const [selectedRange, setSelectedRange] = useState(data ? {
        start:new Date(data.start),
        end: new Date(data.end)
    } : { start: null, end: null });
    const [selectedTimes, setSelectedTimes] = useState(data ? [getTimeStringDate(data.start), getTimeStringDate(data.end)] : ['01:00:00', '01:00:00']); // Initial time values
    const [currentDate, setCurrentDate] = useState(new Date());
    const weekStartIndex = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].indexOf(
        props.startWeekday
    );
    const [currentYear, setCurrentYear] = useState(
        props.selectedDate
            ? new Date(props.selectedDate).getFullYear()
            : currentDate.getFullYear()
    );
    const [currentMonth, setCurrentMonth] = useState(
        props.selectedDate
            ? new Date(props.selectedDate).getMonth()
            : currentDate.getMonth()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (selectedRange && selectedTimes)
            onChangeSelectedDate(selectedRange, selectedTimes);
    }, [selectedRange, selectedTimes, onChangeSelectedDate]);

    useEffect(() => {
        if (data) {
            setSelectedRange({
                start:new Date(data.start),
                end: new Date(data.end)
            })
            setSelectedTimes([getTimeStringDate(data.start), getTimeStringDate(data.end)])
            setCurrentMonth(new Date(data.start).getMonth());
            setCurrentYear(new Date(data.start).getFullYear());
        }
    }, [data]);

    const getMonthData = (year, month) => {
        // Logic to get the data for the specified month and year
        // You can use libraries like date-fns or moment.js for this purpose
        // For simplicity, we'll just return an array of dates for demonstration
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = (lastDay.getDate() - firstDay.getDate()) + 1;

        return Array.from({ length: daysInMonth }, (_, index) => new Date(year, month, index + 1));
    };

    const getWeekdayNames = () => {
        const weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        return weekdays.map((weekday, index) => (
            <div key={`weekday${index}`}>
                {
                    ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][
                        index + weekStartIndex > 6
                            ? index + weekStartIndex - 7
                            : index + weekStartIndex
                    ]
                }
            </div>
        ));
    };
  
    
    const handleDateClick = (date) => {
        count++;
        if (count % 2 === 1) {
            if (!selectedRange.start) {
                // If no start date or both start and end dates are selected, set new start date
                setSelectedRange({ start: date, end: null });
        
              } else if (selectedRange.start && selectedRange.end) {
                if (date > selectedRange.end) return;
                setSelectedRange({ ...selectedRange, start: date });
              
              }
        } else {
            setSelectedRange({ ...selectedRange, end: date });
        }
    };

    const isDateInRange = (date) => {
        if (!selectedRange.start || !selectedRange.end) {
          return false;
        }
    
        return date > selectedRange.start && date < selectedRange.end;
    };

    const dateInSelectedDates = (date, selectedDate) => {
        let isInSelectedDates = false;
        
        if (datesAreOnSameDay(date, selectedDate)) {
            isInSelectedDates = true;
        }

        return isInSelectedDates;
    };

    const datesAreOnSameDay = (first, second) => {
        if (!first || !second) return false;
    
        let _first = new Date(first);
        let _second = new Date(second);
    
        return (
            _first.getFullYear() === _second.getFullYear() &&
            _first.getMonth() === _second.getMonth() &&
            _first.getDate() === _second.getDate()
        );
    };

    const handleTimeChange = useCallback((data, index) => {
        // Update the selected time when the time input changes
        const newSelectedTimes = [...selectedTimes];
        newSelectedTimes[index] = data;
        setSelectedTimes(newSelectedTimes);
    }, [selectedTimes]);
     
    const renderMonth = (year, month, index) => {
      const monthData = getMonthData(year, month);
      const options = { year: 'numeric', month: 'long' };
      const monthName = new Date(year, month, weekStartIndex).toLocaleDateString('en-US', options);

      const firstDayOfWeek = new Date(year, month, 0).getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday  
      return (
        <div className={classes.calendarWrapper} key={index}>
            <div>
            <div className={classes.calendarTop}>
                <div onClick={() => prevMonth(year, month, index)}>{"<"}</div>
                <h1>{`${monthName}`}</h1>
                <div onClick={() => nextMonth(year, month, index)}>{">"}</div>
            </div>           
            
            <div className={classes.weekdayWrapper}>
                {getWeekdayNames().map((weekday, index) => (
            <div key={index}>{weekday}</div>
            ))}
            </div>
            <div className={classes.datesWrapper}>
                {Array.from({ length: firstDayOfWeek }, (_, index) => (
                    <div key={`empty-${index}`} className="empty-day" />
                ))}
                {monthData.map((date) => (
                <div
                    key={date}
                    className={`${classes.calendarDay} 
                        ${isDateInRange(date) ? classes.hoveredDay : ''} 
                        ${dateInSelectedDates(date, selectedRange.start) ? classes.selectedDay : ''}
                        ${dateInSelectedDates(date, selectedRange.end) ? classes.selectedDay : ''}`}
                    onClick={() => handleDateClick(date, index)}
                >
                    <div>{date.getDate()}</div>
                </div>
                ))}
            </div>
            </div>
            <div className={classes.timeRangeWrapper}>
                    <div className={classes.timeRange}>                                           
                        <div key={`selectedTimeRange Time slots`}>
                        <div className={classes.timeWrapper}>
                                {/* <label htmlFor={`timeInput-${index}`}>Hour/Minute</label> */}
                                {/* <input
                                    type="time"
                                    id={`timeInput-${index}`}
                                    value={selectedTimes[index]}
                                    onChange={(event) => handleTimeChange(event, index)}
                                    step="900"
                                /> */}
                                <CustomTimePicker 
                                    data={selectedTimes[index]}
                                    onChange={(data) => handleTimeChange(data, index)}/>                  
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
    };
  
    const nextMonth = (year, month, index) => {
        let nextYear = year;
        let nextMonth = month + 1;
    
        if (nextMonth >= 12) {
          nextYear += 1;
          nextMonth = 0;
        }    
        const nextDate = new Date(nextYear, nextMonth, 1);
        setCurrentDate(nextDate);
      };
    
      const prevMonth = (year, month, index) => {
        let prevYear = year;
        let prevMonth = month - 1;
    
        if (prevMonth <= 1) {
          prevYear -= 1;
          prevMonth = 11;
        }
        const prevDate = new Date(prevYear, prevMonth, 1);
        setCurrentDate(prevDate);
      };
  
    return (
      <div className={classes.calendarsWrapper}>        
          {renderMonth(currentYear, currentMonth, 0)}
          {renderMonth(currentYear, currentMonth + 1, 1)}
      </div>
    );
};
